// extracted by mini-css-extract-plugin
export default {"main":"PxDoUF1isapkwn82NIYl","paymentHeader":"mLtpNQg1MDEBV2FzBosQ","break":"VtHGgtm4yLd0i8y4aoLJ","footer":"jtlRZIT77koGPdYAYcli","certCardContainer":"fxiEMAcDoBVOEiFVilTg"};